import { useMemo } from 'react';

import { getRouteApi, type RouteApi } from '@mint/routing';

const ED_BASE = '/external-data/integrations';

export const getIntegrationPaths = () => {
  return {
    index: `${ED_BASE}/`,
    integrations: `${ED_BASE}`,
    integrationTab: `${ED_BASE}/$integration/$tabName`,
    integrationType: `${ED_BASE}/$integration/$tabName/$type`,
    integrationTypeSlash: `${ED_BASE}/$integration/$tabName/$type/`,
    connectionsAdd: `${ED_BASE}/$integration/connections/add`,
  } as const;
};

export const useIntegrationPaths = () => {
  return useMemo(() => getIntegrationPaths(), []);
};

const edLayout = getRouteApi(
  '/_secured/external-data/integrations/$integration/$tabName',
);

const edIndex = getRouteApi('/_secured/external-data/integrations/');

const edType = getRouteApi(
  '/_secured/external-data/integrations/$integration/$tabName/$type/',
);

export const useIntegrationLayoutRouteApi =
  (): RouteApi<'/_secured/external-data/integrations/$integration/$tabName'> =>
    edLayout;

export const useIntegrationsIndexRouteApi =
  (): RouteApi<'/_secured/external-data/integrations/'> => edIndex;

export const useIntegrationAccountTypeRouteApi =
  (): RouteApi<'/_secured/external-data/integrations/$integration/$tabName/$type/'> =>
    edType;
